import TimelineMessageCard from '../TimelineMessageCard';

const NotasInternasList = ({ notas = [] }) => {
    if (!notas.length) {
        return (
            <span style={{ color: '#9e9e9e', fontSize: '0.85rem' }}>
                No hay notas internas.
            </span>
        );
    }

    return (
        <div className="d-flex flex-column" style={{ gap: 10 }}>
            {notas.map((nota, idx) => (
                <TimelineMessageCard
                    key={nota.id || idx}
                    accentColor="#5c636a"
                    usuario={nota.usuario}
                    fechaHora={nota.fecha_hora}
                    body={nota.nota}
                />
            ))}
        </div>
    );
};

export default NotasInternasList;
